"use strict";
/**
 * The primary market picker's filter state (pure logic: `markets/market-filter.ts`).
 *
 * The chosen TYPE is a standing preference, kept across events and a refresh:
 * an event that has it opens filtered to it, one that lacks it shows all
 * types, and the preference waits for the next event. The TEXT term belongs
 * to one event — names don't carry over — so a new event clears it.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrimaryFilter = getPrimaryFilter;
exports.resetPrimaryFilterForEvent = resetPrimaryFilterForEvent;
exports.setPrimaryFilterCategory = setPrimaryFilterCategory;
exports.setPrimaryFilterText = setPrimaryFilterText;
exports.__resetPrimaryFilterForTests = __resetPrimaryFilterForTests;
const market_filter_1 = require("../markets/market-filter");
const STORAGE_KEY = "kalshi_primary_market_type";
let preferred = readPreference();
let active = market_filter_1.NO_FILTER;
function readPreference() {
    try {
        return localStorage.getItem(STORAGE_KEY) || null;
    }
    catch {
        return null;
    }
}
function writePreference(category) {
    try {
        if (category)
            localStorage.setItem(STORAGE_KEY, category);
        else
            localStorage.removeItem(STORAGE_KEY);
    }
    catch {
        // Private mode or blocked storage: the preference lasts this page only.
    }
}
function getPrimaryFilter() {
    return active;
}
/** A new event: its filter is the preferred type if it has one, and no text. */
function resetPrimaryFilterForEvent(markets) {
    active = { category: preferred && (0, market_filter_1.hasCategory)(markets, preferred) ? preferred : null, text: "" };
    return active;
}
/** The operator picked a chip; "All" (null) clears the preference too. */
function setPrimaryFilterCategory(category) {
    preferred = category;
    writePreference(category);
    active = { ...active, category };
    return active;
}
function setPrimaryFilterText(text) {
    active = { ...active, text };
    return active;
}
/** Test-only: forget the preference and the active filter. */
function __resetPrimaryFilterForTests() {
    preferred = readPreference();
    active = market_filter_1.NO_FILTER;
}
